/// <amd-module name="VSS/Features/Directory/DirectoryGrid" />
export * from "./Components/DirectoryGrid/index";
